import React from 'react';
import Hyperlink from '../../../../components/atoms/Hyperlink/Hyperlink';
import ILink from '../../../../types/ILink';

export function PersonLink({ person }: { person: ILink }) {
  return (
    <Hyperlink to={person.url} className="meta-info__name--link">
      {person.name}
    </Hyperlink>
  );
}
